// Families about to get a batched "your lesson schedule changed" notice
// (utils/schedule_notices.py) — shared by every calendar's ScheduleNoticeBar.
// Teachers see only notices for their own changes; admins see all.
import { ref } from 'vue'
import { useApi } from './useApi.js'

export const pendingNotices = ref([])

export async function refreshScheduleNotices() {
  try {
    pendingNotices.value = await useApi().fetchApi('/api/schedule-notices/pending')
  } catch {
    // keep the last list; the bar is informational
  }
}

export async function sendScheduleNoticesNow() {
  await useApi().fetchApi('/api/schedule-notices/send-now', {
    method: 'POST', body: JSON.stringify({ ids: pendingNotices.value.map(n => n.id) }),
  })
  await refreshScheduleNotices()
}
